// Chakra 
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';

// Assets
import { parseDateTime } from 'services/Utils';
import { textLang } from 'services/Lang';

const WonModal = ({handle, onOpen, isOpen, onClose, amount, error, time}) => {
  return (
    	<> 
        <Modal isOpen={isOpen}>
          <ModalOverlay />
          <ModalContent className="modal__simple" 
              maxW={{ base: '330px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
              
              { !error ?             
              <Box position="relative" p="24px" bg='white !important' textAlign="center">

                  <Text variant="title-lg">
                    {textLang('spin_wheel_win_1')} {amount} {textLang('spin_wheel_win_2')}
                  </Text>

                  <Text variant="text-md" mt="8px">
                    {textLang('spin_wheel_win_text')}
                  </Text>

                  <Flex mt="18px" gap="12px">
                    <Button variant="button-md" onClick={() => { handle(); onClose(); }}>{textLang('spin_wheel_win_claim_1')} {amount} {textLang('spin_wheel_win_claim_3')}</Button>
                  </Flex>
              </Box>
              :
              <Box position="relative" p="24px" bg='white !important' textAlign="center">
                  <Text variant="title-lg">
                    {textLang('spin_wheel_title')}
                  </Text>

                  <Text variant="text-md" mt="8px">
                    {textLang('spin_wheel_win_time_1')} {parseDateTime(time)} {textLang('spin_wheel_win_time_2')}
                  </Text>

                  <Flex mt="18px" gap="12px">
                    <Button variant="button-md" onClick={() => { handle(); onClose(); }}>{textLang('spin_wheel_ok')}</Button>
                  </Flex>
              </Box>
              }

          </ModalContent>
        </Modal> 
      </>
  );
};

export default WonModal;